import { importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, TitleStrategy } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { routes } from './app.routing';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { AuthModule } from '@michelin/auth';
import { environment } from 'src/environments/environment';
import { provideStore } from '@ngxs/store';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { AnalyseState } from './features/analyse/state/analyse.state';
import { FuelPriceState } from './features/fuel-price/states/fuel-price.state';
import { ImportState } from './features/imports/state/import.state';
import { LeverState } from './features/levers/states/lever.state';
import { PBIState } from './shared/states/pbiembedded/pbiembedded.state';
import { provideMatomo, withRouter } from 'ngx-matomo-client';
import { TemplatePageTitleStrategy } from './core/template-page-title-strategy';
import { LanguageState} from './core/services/state/language.state';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEn, 'esp');

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi() // For import providers from DI
    ),
    importProvidersFrom(AuthModule.forRoot(environment.auth)),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    provideStore([ImportState, AnalyseState, LeverState, FuelPriceState, PBIState, LanguageState], withNgxsReduxDevtoolsPlugin()),
    provideMatomo(
      {
        trackerUrl: environment.matomo.trackerUrl,
        siteId: environment.matomo.siteId,
        disabled: !environment.production
      },
      withRouter()
    ),
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategy }
  ]
};
